<div
  class="loading-overlay"
  [class.loading-overlay--exit]="fadeOut()"
  role="status"
  [attr.aria-label]="'common.loadingTitle' | transloco: { title: title() }"
>
  <div class="logo-wrapper" aria-hidden="true">
    <div class="arc arc--outer-b"></div>
    <div class="arc arc--outer-a"></div>
    <div class="arc arc--glow"></div>
    <div class="arc arc--a"></div>
    <div class="arc arc--b"></div>
    <div class="logo-container" style="position:relative;z-index:1;width:72px;">
      <img
        class="logo"
        src="images/logo/partnercore-icon.webp"
        alt=""
        fetchpriority="high"
        width="462"
        height="502"
        style="display:block;width:100%;height:auto;"
      />
    </div>
  </div>

  <span class="brand-label">{{ title() }}</span>

  <div class="progress-bar" aria-hidden="true">
    <div class="progress-bar__fill"></div>
  </div>
</div>
